import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Chart.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class PartnerMedia extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            type: {},
            partner: {},
            path: {}
        };
    }

    static listUrl({ organizationId, partnerId }) {
        if (!organizationId || !partnerId) {
            throw new ArgumentError('[Model][PartnerMedia] organizationId and partnerId are mandatory');
        }
        return `/ticket/organizations/${organizationId}/partners/${partnerId}/media`;
    }
}
